import React, { Suspense, lazy } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import './FormLoader.css';

// Lazy load all form components for code splitting
const Backpay = lazy(() => import('../Backpay/Backpay'));
const Bonus = lazy(() => import('../Bonus/Bonus'));
const Hotel = lazy(() => import('../Hotel/Hotel'));
const Mileage = lazy(() => import('../Mileage/Mileage'));
const NonMnMileage = lazy(() => import('../NonMnMileage/NonMnMileage'));
const NewHire = lazy(() => import('../NewHire/NewHire'));
const PerDiem = lazy(() => import('../PerDiem/PerDiem'));
const Pto = lazy(() => import('../Pto/Pto'));
const TargetOrder = lazy(() => import('../TargetOrder/TargetOrder'));
const Termination = lazy(() => import('../Termination/Termination'));
const TimeAdjustment = lazy(() => import('../TimeAdjustment/TimeAdjustment'));
const Uniform = lazy(() => import('../Uniform/Uniform'));
const WorkTicket = lazy(() => import('../WorkTicket/WorkTicket'));

// Map form names to components
const FORM_COMPONENTS = {
  backPay: Backpay,
  bonus: Bonus,
  hotel: Hotel,
  mileage: Mileage,
  nonMnMileage: NonMnMileage,
  newHire: NewHire,
  perDiem: PerDiem,
  pto: Pto,
  targetOrder: TargetOrder,
  termination: Termination,
  timeAdjustment: TimeAdjustment,
  uniform: Uniform,
  workTicket: WorkTicket,
};

/**
 * Loading fallback component
 */
const FormLoadingFallback = () => (
  <div className="form-loading-container">
    <FontAwesomeIcon
      icon={faSpinner}
      spin
      size="2xl"
      className="form-loading-spinner"
    />
    <p className="form-loading-text">Loading form...</p>
  </div>
);

/**
 * FormLoader Component
 * Handles lazy loading of form components with Suspense
 *
 * @param {string} formName - Name of the form to load
 * @param {object} props - Props to pass to the form component
 */
const FormLoader = ({ formName, ...props }) => {
  const FormComponent = FORM_COMPONENTS[formName];

  if (!FormComponent) {
    return (
      <div className="form-error-container">
        <p className="form-error-text">Form "{formName}" not found.</p>
      </div>
    );
  }

  return (
    <Suspense fallback={<FormLoadingFallback />}>
      <FormComponent {...props} />
    </Suspense>
  );
};

export default FormLoader;
